import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../mensajes";

export const CambioClave = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const login = JSON.parse(localStorage.getItem("login"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const txtContraseña = useRef();
  const txtContraseñaNueva = useRef();
  const txtConfirmar = useRef();
  const [message, setMessage] = useState("hidden");
  const [teclas, setTeclas] = useState();
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tipoActual, setTipoActual] = useState("password");
  const [tipoNuevo, setTipoNuevo] = useState("password");
  const [deshabilitado, setDesabilitado] = useState(true);
  const [deshabilitarBtn, setDesabilitarBtn] = useState(true);

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const handleCloseSi = () => {
    procesarRegistro();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const blanquear = () => {
    txtContraseñaNueva.current.value = "";
    txtContraseña.current.value = "";
    txtConfirmar.current.value = "";
    setDesabilitado(true);
    setDesabilitarBtn(true);
    setTipoActual("password");
    setTipoNuevo("password");
  };

  const SelectUsuario = (passwd) => {
    let endpoint = `${op.conexion}/api/comun/validarpass?passwd=${passwd}&login=${login}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          if (response.data !== "") {
            console.log(response.data);
            setDesabilitado(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "La Contraseña es Invalida",
              icono: "informacion",
            });
            txtContraseñaNueva.current.value = "";
            txtConfirmar.current.value = "";
            setDesabilitado(true);
            setDesabilitarBtn(true);
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarPropie = (event) => {
    event.preventDefault();

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTeclas(event.which);
        SelectUsuario(event.target.value);
      }
    }
  };

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/comun/cambioclave/usuariotimbre`;
    setActivate(true);
    let body = {
      passwd: txtContraseñaNueva.current.value,
      login: login,
      idusuario: idusuario,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "La Contraseña fue cambiada.",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Cambiar Contraseña",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (txtContraseña.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La contraseña actual no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtContraseña.current.focus();
    } else if (txtContraseñaNueva.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Contraseña nueva no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtContraseñaNueva.current.focus();
    } else if (txtConfirmar.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Debe Confirmar la Contraseña ",
        icono: "informacion",
      });
      sigue = false;
      txtConfirmar.current.focus();
    }

    if (sigue) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta seguro de Cambiar su contraseña?",
        icono: "confirmacion",
      });
    }
  };

  const onChange = (e) => {
    if (e.target.name === "confirmar") {
      if (
        txtContraseñaNueva.current.value.trim() ===
        txtConfirmar.current.value.trim()
      ) {
        setMessage("hidden");
        setDesabilitarBtn(false);
      } else {
        setMessage("visible");
        setDesabilitarBtn(true);
      }
    }
  };

  const verClave = (tipo) => (e) => {
    e.preventDefault();
    if (tipo === 1) {
      if (tipoActual === "password") {
        setTipoActual("text");
      } else {
        setTipoActual("password");
      }
    } else if (tipo === 2) {
      if (tipoNuevo === "password") {
        setTipoNuevo("text");
      } else {
        setTipoNuevo("password");
      }
    }
  };
  const cerrarModal = () => {
    props.render();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {}, []);
  //console.log(values)

  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Cambiar Clave</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <div className="container-fluid  rounded row mx-auto">
          <div class="mb-1">
            <label for="exampleInputEmail1" class="form-label">
              Contraseña Actual:
            </label>
            <div class="input-group input-group-sm ">
              <input
                type={tipoActual}
                class="form-control"
                aria-label="Sizing example input"
                name="passw"
                ref={txtContraseña}
                onKeyUp={validarPropie}
                onBlur={validarPropie}
                aria-describedby="inputGroup-sizing-sm"
              />
              <button type="button" class="btn btn-info" onClick={verClave(1)}>
                <i class="far fa-eye"></i>
              </button>
            </div>
          </div>

          <div class="mb-1">
            <label for="exampleInputEmail1" class="form-label">
              Contraseña Nueva:
            </label>
            <div class="input-group input-group-sm ">
              <input
                type={tipoNuevo}
                class="form-control"
                aria-label="Sizing example input"
                ref={txtContraseñaNueva}
                disabled={deshabilitado}
                aria-describedby="inputGroup-sizing-sm"
              />
              <button type="button" class="btn btn-info" onClick={verClave(2)}>
                <i class="far fa-eye"></i>
              </button>
            </div>
          </div>

          <div class="mb-1">
            <label for="exampleInputEmail1" class="form-label">
              Confirmar Contraseña:
            </label>
            <div class="input-group input-group-sm ">
              <input
                type={tipoNuevo}
                class="form-control"
                aria-label="Sizing example input"
                name="confirmar"
                ref={txtConfirmar}
                disabled={deshabilitado}
                onKeyUp={onChange}
                aria-describedby="inputGroup-sizing-sm"
              />
              <div
                style={{ visibility: message }}
                class="form-text col-md-12 text-danger fw-bold text-center"
              >
                Las Contraseñas no Coinciden.
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          style={{ margin: "1px" }}
          onClick={onChangeValidar}
          disabled={deshabilitarBtn}
          className=" btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          onClick={cancelar}
          style={{ margin: "1px" }}
          className=" btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/recuperacionInfo/cambiarComtraseña.js